/* @flow */
import * as React from 'react';
import { css, names } from 'linaria';

type Props = {
  children?: any,
  className?: string,
  onClick?: (evt: Object) => void,
  type?: string,
};

type State = {
  hover: boolean,
};

class PlainButton extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hover: false };
  }

  _onPointerEnter = () => {
    this.setState({ hover: true });
  };

  _onPointerLeave = () => {
    this.setState({ hover: false });
  };

  render() {
    const { className, children, onClick, ...rest } = this.props;
    const { hover } = this.state;
    return (
      <button
        className={names(Styles.Button, className)}
        onClick={onClick}
        onMouseEnter={this._onPointerEnter}
        onMouseLeave={this._onPointerLeave}
        {...rest}>
        {typeof children === 'function' ? children(hover) : children}
      </button>
    );
  }
}

export default PlainButton;

const Styles = {
  Button: css`
    cursor: pointer;
    outline: none;
    border: none;
    background-color: transparent;
    appearance: none;
    padding: 0;
    text-align: center;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  `,
};



// WEBPACK FOOTER //
// ./src/ui/components/core/PlainButton.js